import { faEnvelope } from "@fortawesome/pro-regular-svg-icons";
import { useForm } from "react-hook-form";

import { T, useT } from "@repo/transifex";
import { LogoRocket } from "~/components/kiosk/svgs/rocket";
import { EMAIL_REGEX } from "~/utils/constants";

import { Modal } from "../../shared/modal";
import { ModalButton } from "../../shared/modal-button";
import { ModalButtonGroup } from "../../shared/modal-button-group";
import { ModalTitle } from "../../shared/modal-title";

type ModalEmailProps = {
  onGoBack: () => void;
  onSendReceipt: (email: string) => void;
};

type FormData = {
  email: string;
};

export const ModalEmail = ({ onGoBack, onSendReceipt }: ModalEmailProps) => {
  const t = useT();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm<FormData>();

  return (
    <Modal open backdropVariant="success">
      <div className="flex flex-col items-center gap-y-16">
        <LogoRocket />
        <ModalTitle size="8xl" variant="normal" weight="black">
          <T _str="Input your email" />
        </ModalTitle>
        <form
          className="flex w-full max-w-3xl flex-col items-center gap-y-16"
          onSubmit={handleSubmit(({ email }) => {
            onSendReceipt(email);
            reset();
          })}
          noValidate
        >
          <div className="flex w-full flex-col items-center gap-y-4">
            <input
              {...register("email", {
                required: t("Email is required"),
                pattern: {
                  value: EMAIL_REGEX,
                  message: t("Invalid email address")
                }
              })}
              className="w-full bg-kiosk-background-success px-8 py-4 text-center text-5xl font-extralight text-kiosk-text-primary outline-none placeholder:text-kiosk-text-light"
              type="email"
              placeholder={t("Enter email")}
            />
            {errors.email ? (
              <span role="alert" className="font-light text-kiosk-text-error">
                {errors.email.message}
              </span>
            ) : null}
          </div>
          <ModalButtonGroup>
            <ModalButton onClick={onGoBack} variant="success" size="medium">
              <p className="text-4xl">
                <T _str="Go back" />
              </p>
            </ModalButton>
            <ModalButton
              variant="success"
              size="medium"
              icon={faEnvelope}
              type="submit"
            >
              <p className="text-4xl">
                <T _str="Send receipt" />
              </p>
            </ModalButton>
          </ModalButtonGroup>
        </form>
      </div>
    </Modal>
  );
};
